import React, { useState } from "react";
import { Switch } from "antd";
import AttributeFormGroup from "./shared/attribureFormGroup";
import { useSelector, useDispatch } from "react-redux";
import { updateUI } from "../../../store/actions/deviceProfile";

function CreateDeviceProfileStep2() {
  const dispatch = useDispatch();
  const { formFields, attributes, autoResolveForAllAlert } = useSelector((state) => ({
    formFields: state.deviceProfile.ui.form.fields,
    attributes: state.deviceProfile.ui.form.fields.step1.attributes,
    autoResolveForAllAlert: state.deviceProfile.ui.form.fields.step2.autoResolveForAllAlert,
  }));

  const [expandedSection, setExpandedSection] = useState(null);

  const handleAutoResolve = (change) => {
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step2: {
              ...formFields.step2,
              autoResolveForAllAlert: change,
            },
          },
        },
      })
    );
  };

  return (
    <>
      <div className="font-face-vzw" style={{ fontWeight: 700, fontSize: "30px" }}>
        Attributes
      </div>
      <div className="device-profile-create-modal-container">
        {Array.isArray(attributes) &&
          attributes.length > 0 &&
          attributes.map((attribute) => (
            <AttributeFormGroup
              key={attribute?.stateSelector}
              title={
                attribute?.title?.startsWith("rfSignal")
                  ? "Cellular Signal Strength (dBm)"
                  : attribute?.title
              }
              stateSelector={attribute?.stateSelector}
              isMinimumVisible={attribute?.isMinimumVisible}
              expandedSection={expandedSection}
              setExpandedSection={setExpandedSection}
            />
          ))}
      </div>
      <div className="d-flex flex-row justify-content-start align-items-center" style={{ padding: "8px 0px", margin: "24px 0px" }}>
        <div className="font-face-vzw" style={{ fontWeight: 700, fontSize: "16px" }}>
          Enable Auto-Resolve for all alerts
        </div>
        <div className="px-2">
          <Switch
            style={
              autoResolveForAllAlert
                ? { backgroundColor: "#008331" }
                : { backgroundColor: "#d8dada" }
            }
            checked={autoResolveForAllAlert}
            onChange={handleAutoResolve}
          />
        </div>
      </div>
    </>
  );
}

export default CreateDeviceProfileStep2;